import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, startWith, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-layout-classic',
    templateUrl: './classic.component.html',
    styleUrls: ['./classic.component.scss'],
})
export class LayoutClassicComponent implements OnInit, OnDestroy {
    /** Routes flagged `fullBleed` render edge to edge, without the page gutter. */
    fullBleed = false;

    private destroy$ = new Subject<void>();

    constructor(private router: Router, private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                startWith(null),
                takeUntil(this.destroy$),
            )
            .subscribe(() => {
                let deepest = this.route;
                while (deepest.firstChild) {
                    deepest = deepest.firstChild;
                }
                this.fullBleed = !!deepest.snapshot.data?.fullBleed;
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
